import * as React from "react";

function SvgEverflow(props, ref) {
  return (
    <svg
      id="Everflow_svg__Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 297.28 277.28"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".Everflow_svg__cls-1{fill:#4332a5}"}</style>
      </defs>
      <path
        className="Everflow_svg__cls-1"
        d="M243.61 79.22H99l33.44-66.82A22.41 22.41 0 01152.49 0h144.59l-33.41 66.83a22.44 22.44 0 01-20.06 12.39z"
      />
      <path
        d="M198 99l-33.4 66.82a22.43 22.43 0 01-20 12.41H0l33.4-66.82A22.43 22.43 0 0153.47 99z"
        fill="#f7dc4c"
      />
      <path
        className="Everflow_svg__cls-1"
        d="M164.39 277.28H19.8l33.41-66.83a22.44 22.44 0 0120.06-12.39h144.59l-33.42 66.82a22.42 22.42 0 01-20.05 12.4z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgEverflow);
